export enum StockTypes {
    Default,
    Refurbished,
    ExDisplay
}